import { render, staticRenderFns } from "./Parents.vue?vue&type=template&id=75dcd8c6&scoped=true&"
import script from "./Parents.vue?vue&type=script&lang=js&"
export * from "./Parents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75dcd8c6",
  null
  
)

export default component.exports